import Vue from 'vue'
import { industria as routing } from '../util/routes'

export default {
  state: {
    industria: {},
    industrias: [],
    paginateIndustrias: {
      data: []
    },
    industriaPage: 1,
    industriaFilter: ''
  },
  mutations: {
    setIndustria: (state, payload) => {
      state.industria = payload
    },
    setIndustrias: (state, payload) => {
      state.industrias = payload
    },
    setPaginateIndustrias: (state, payload) => {
      state.paginateIndustrias = payload
    },
    setIndustriaPage: (state, payload = 1) => {
      state.industriaPage = payload
    },
    setIndustriaFilter: (state, payload = '') => {
      state.industriaFilter = payload
    }
  },
  actions: {
    async getPaginateIndustrias ({ commit, state }, payload) {
      commit('setPaginateIndustrias', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.industriaPage,
          filter: state.industriaFilter
        }
      })
      commit('setPaginateIndustrias', data)
    },
    async getIndustrias ({ commit }, payload) {
      commit('setIndustrias', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0,
          ...payload
        }
      })
      commit('setIndustrias', data)
    },
    async getIndustria ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setIndustria', data)
    },
    async postSaveIndustria ({ state }) {
      const { industria } = state
      if (industria.inscricao_isento) delete industria.inscricao_estadual
      if (industria.id) {
        return Vue.axios.put(`${routing}/${industria.id}`, industria)
      }
      return Vue.axios.post(`${routing}`, industria)
    },
    async deleteIndustria ({ state }) {
      const { industria } = state
      return Vue.axios.delete(`${routing}/${industria.id}`)
    },
    async uploadLogotipo ({ state }, payload) {
      const { industria } = state
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      return Vue.axios.post(
        `${routing}/${industria.id}/upload`,
        payload,
        config
      )
    },
    async removeLogotipo ({ state }, payload) {
      const { industria } = state
      return Vue.axios.delete(`${routing}/${industria.id}/upload`)
    }
  },
  getters: {
    industria: ({ industria }) => industria,
    industriaPage: ({ industriaPage }) => industriaPage,
    industriaFilter: ({ industriaFilter }) => industriaFilter,
    industrias: ({ industrias }) => industrias,
    paginateIndustrias: ({ paginateIndustrias }) => paginateIndustrias
  }
}
